import { safeLocalStorage } from "../../utils/safeLocalStorage";

export const isJWTAuthorized = () => {
  const AT = safeLocalStorage.getItem("__AT");
  const RT = safeLocalStorage.getItem("__RT");
  return Boolean(AT && RT);
};
